import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { AddPackagesData } from '@app/shared/components/dialogs/add-package-dialog/add-package-dialog.data';

@Component({
    selector : 'add-package-dialog',
    template: require('./add-package-dialog.component.html'),
    styles: [require('./add-package-dialog.component.scss')]
})
export class AddPackageDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: AddPackagesData) {
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/add-package-dialog/add-package-dialog.component.ts